import React, { useContext } from 'react';

import { languageOptions } from '../languages';

import { LanguageContext } from '../helpers/language';

export default function LanguageSelector() {
  const languageContext = useContext(LanguageContext);

  const handleLanguageChange = (event) => {
    const selectedLanguage = languageOptions.find(item => item.id === event.target.value);
    //store the selected language in the local storage
    localStorage.setItem('language', JSON.stringify(selectedLanguage));
    // set selected language by calling context method
    languageContext.setLanguage(selectedLanguage);
    //added this to make sure al components load the correct language
    window.location = window.location;    
  };
  
  return (    
    <select
      className='languageSelect'
      onChange={handleLanguageChange}
      value={languageContext.language.id}
    >
      {languageOptions.map(item => (
        <option
          key={item.id}
          value={item.id}
        >
          {item.text}
        </option>
      ))}
    </select>
  );
};